import { FileText } from 'lucide-react'
import { Upload } from 'antd'

import ActionIcon from './ActionIcon'
import useInputUpload from '@/hooks/useInputUpload'
import { DocFileAccept } from '@/constants/index'
const Icon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 18H15.25C15.7141 18 16.1592 17.8207 16.4874 17.5015C16.8156 17.1822 17 16.7493 17 16.2979V6.67768C17 6.40765 16.8908 6.14911 16.6972 5.96084L12.9161 2.28316C12.7294 2.10159 12.4793 2 12.2189 2H4.75C4.28587 2 3.84075 2.17933 3.51256 2.49854C3.18437 2.81775 3 3.2507 3 3.70213V9.14894"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.6665 12.25C3.6665 11.8358 3.33072 11.5 2.9165 11.5C2.50229 11.5 2.1665 11.8358 2.1665 12.25V13.1667H1.25C0.835786 13.1667 0.5 13.5025 0.5 13.9167C0.5 14.331 0.835786 14.6667 1.25 14.6667H2.1665V15.5833C2.1665 15.9975 2.50229 16.3333 2.9165 16.3333C3.33072 16.3333 3.6665 15.9975 3.6665 15.5833V14.6667H4.58333C4.99755 14.6667 5.33333 14.331 5.33333 13.9167C5.33333 13.5025 4.99755 13.1667 4.58333 13.1667H3.6665V12.25Z"
      fill="#0077FA"
    />
    <path
      d="M7 7.9989H12"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 11.9989H9"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const DocUpload = () => {
  const { uploadLoading, beforeUploadDoc } = useInputUpload()
  const tipText = `支持${DocFileAccept.join(
    '、',
  )}文档格式，一次最多上传一个文件，单次不超过10M`

  return (
    <Upload
      accept={DocFileAccept.join(',')}
      beforeUpload={beforeUploadDoc}
      maxCount={1}
      showUploadList={false}
    >
      <ActionIcon title={tipText} Icon={Icon} loading={uploadLoading} />
    </Upload>
  )
}

export default DocUpload
